import { component } from 'picoapp'
import { deviceType } from "detect-it"

export default class SearchModal {
  constructor() {
    // bindings
    this.activateSearchModal = this.activateSearchModal.bind(this)
    this.suspendSearchModal = this.suspendSearchModal.bind(this)
    this.clickToClose = this.clickToClose.bind(this)
    this.resetModal = this.resetModal.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.clickOutsideToClose = this.clickOutsideToClose.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onFocusOut = this.onFocusOut.bind(this)

    // privates
    this._search_modal = document.getElementById('search-modal')
    this._close_btn = document.getElementById('search-close-btn')
    this._search_input = this._search_modal.querySelector('.search-input')
    this._search_bar_btn = document.getElementById('search-bar-btn')
    this._search_results = document.getElementById('search-results')
    this._search_content = document.getElementById('search-content')
    this._product_cards = Array.from(this._search_modal.getElementsByClassName('product-card'))
    this._results = 0
    this._input_time = null
  }

  clickToClose(e) {
    this.suspendSearchModal()
  }

  clickOutsideToClose(e) {
    let id = e.target.getAttribute('id')

    if (id === 'search-modal' || id === 'search-modal-inner') {
      this.suspendSearchModal()
    }
  }

  resetModal() {
    this._results = 0
    this._input_time = null
    this._search_input.value = ""
    this._search_modal.classList.remove('has-results')
    this._search_modal.classList.remove('no-results')

    this._search_content.offsetHeight
    this._search_content.scrollTop = 0
    this._search_input.focus()
  }

  onKeyUp(e) {
    if (e.keyCode === 27) {
      this.suspendSearchModal()
    }

    if (e.keyCode === 13) {
      if (document.activeElement === this._search_input) {
        this.onSearchSubmit()
      }
    }
  }

  onInputChange() {
    clearTimeout(this._input_time)

    if (deviceType === 'mouseOnly') {
      this._input_time = setTimeout(() => {
        let search_val = this._search_input.value.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '')

        if (search_val !== '') {
          this.onSearchSubmit()
        }
      }, 250)
    }
  }

  onFocusOut() {
    if (deviceType !== 'mouseOnly') {
      let search_val = this._search_input.value.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '')

      if (search_val !== '') {
        this.onSearchSubmit()
      }
    }
  }

  onSearchSubmit() {
    let search_val = this._search_input.value.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '')

    this._search_modal.classList.remove('has-results')
    this._search_modal.classList.remove('no-results')
    this._results = 0

    if (search_val != '') {
      search_val = search_val.split('-')

      this._product_cards.forEach((el) => {
        let parent = el.parentElement,
            title = el.dataset.title.replace(/-/g, ' '),
            tags = `${title} ${el.dataset.tags.replace(/,|-/g, ' ')}`,
            match = 0;

        parent.style.display = "none"

        search_val.forEach((word) => {
          if (tags.includes(word)) {
            match++
          }
        })

        if (match === search_val.length) {
          parent.style.display = "flex"
          this._results++
        }
      })
    } else {
      this._product_cards.forEach((el) => {
        el.parentElement.style.display = "none"
      })
    }

    if ('ontouchstart' in document.documentElement) {
      document.activeElement.blur()
    }

    if (this._results === 0) {
      this._search_modal.style.display = 'none'
      this._search_modal.classList.remove('has-results')

      this._search_modal.offsetHeight
      this._search_modal.style.display = 'block'
      this._search_modal.offsetHeight
      this._search_modal.classList.add('no-results')
    } else {
      this._search_modal.classList.remove('no-results')
      this._search_modal.classList.add('has-results')
    }
  }

  activateSearchModal() {
    document.body.classList.add('lock')
    this._search_modal.style.display = 'block'
    this._search_modal.offsetHeight
    this._search_modal.classList.add('show')

    this._close_btn.addEventListener('click', this.clickToClose, false)
    this._search_bar_btn.addEventListener('click', this.onSearchSubmit, false)
    this._search_input.addEventListener('input', this.onInputChange, false)
    this._search_input.addEventListener('focusout', this.onFocusOut, false)
    this._search_modal.addEventListener('click', this.clickOutsideToClose, false)
    document.addEventListener('keyup', this.onKeyUp, false)

    this.resetModal()
  }

  suspendSearchModal() {
    document.body.classList.remove('lock')

    this._close_btn.removeEventListener('click', this.clickToClose, false)
    this._search_bar_btn.removeEventListener('click', this.onSearchSubmit, false)
    this._search_input.removeEventListener('input', this.onInputChange, false)
    this._search_input.removeEventListener('focusout', this.onFocusOut, false)
    this._search_modal.removeEventListener('click', this.clickOutsideToClose, false)
    document.removeEventListener('keyup', this.onKeyUp, false)

    this._search_modal.offsetHeight
    this._search_modal.classList.remove('show')
    setTimeout(() => {
      this._search_modal.style.display = 'none'
    }, 666)
  }
}
